<template>
    <div v-if="clipart && clipart.clipart && clipart.clipart.file">
        <show-image :width="clipart.width" :height="clipart.height" :src="clipart.clipart.file" alt="CLIPART" />
    </div>
</template>

<script>
import ShowImage from '@/components/General/ShowImage';
export default {
    name: "show-clipart",
    components: {
        ShowImage
    },
    props: {
        clipart: {
            type: Object
        }
    }
}
</script>

<style scoped>

</style>